import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { safeT } from '@/shared/localization';
import { useTranslations } from 'next-intl';
import { useMetadata } from './useMetaData';
export default function useVideoMeta() {
  const $ = _c(26);
  const t = useTranslations("meta");
  const {
    data: t0
  } = useMetadata();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      video: {
        ratios: [],
        resolutions: [],
        lengths: [],
        styles: [],
        previews: []
      }
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const meta = t1;
  let t2;
  if ($[2] !== meta.video.ratios || $[3] !== t) {
    let t3;
    if ($[5] !== t) {
      t3 = ratio => ({
        label: safeT(t, `video.ratio.${ratio}`, ratio),
        value: ratio
      });
      $[5] = t;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = meta.video.ratios.map(t3);
    $[2] = meta.video.ratios;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const ratios = t2;
  let t3;
  if ($[7] !== meta.video.resolutions || $[8] !== t) {
    let t4;
    if ($[10] !== t) {
      t4 = resolution => ({
        label: safeT(t, `video.resolution.${resolution}`, resolution),
        value: resolution
      });
      $[10] = t;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = meta.video.resolutions.map(t4);
    $[7] = meta.video.resolutions;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const resolutions = t3;
  let t4;
  if ($[12] !== meta.video.lengths) {
    t4 = meta.video.lengths.map(_temp);
    $[12] = meta.video.lengths;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const lengths = t4;
  let t5;
  if ($[14] !== meta.video.previews || $[15] !== meta.video.styles || $[16] !== t) {
    let t6;
    if ($[18] !== meta.video.previews || $[19] !== t) {
      t6 = style => ({
        label: safeT(t, `video.style.${style}`, style),
        value: style,
        previewUrl: meta.video.previews.find(preview => preview.key === style)?.image ?? ""
      });
      $[18] = meta.video.previews;
      $[19] = t;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t5 = meta.video.styles.map(t6);
    $[14] = meta.video.previews;
    $[15] = meta.video.styles;
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const styles = t5;
  let t6;
  if ($[21] !== lengths || $[22] !== ratios || $[23] !== resolutions || $[24] !== styles) {
    t6 = {
      styles,
      ratios,
      resolutions,
      lengths
    };
    $[21] = lengths;
    $[22] = ratios;
    $[23] = resolutions;
    $[24] = styles;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
function _temp(length) {
  return {
    value: length.toString()
  };
}